import "yet-another-react-lightbox/styles.css";
import "./src/assets/css/main.scss";

export const onInitialClientRender = async () => {
  const UIkit = (await import("uikit")).default;
  const Icons = (await import("uikit/dist/js/uikit-icons")).default;
  UIkit.use(Icons);
};

